"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3236],{

/***/ 29918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AdvertisementSlot": function() { return /* reexport */ AdvertisementSlot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/@editor/index.ts


var useEditorHandlers = function(name, configuration) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_advertisement_slot_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.divider
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Label"
            },
            {
                name: "theme_component_advertisement_slot_label_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_advertisement_slot_label_color",
                label: "Text color",
                type: "color",
                default: theme.palette.secondary.contrastText
            }, 
        ],
        configuration: configuration
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/utils/use-local-storage.ts
var use_local_storage = __webpack_require__(18714);
;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/AdvertisementSlot.tsx















var AD_SIZES = {
    "120x600": {
        width: 120,
        height: 600
    },
    "160x600": {
        width: 160,
        height: 600
    },
    "300x600": {
        width: 300,
        height: 600
    },
    "320x50": {
        width: 320,
        height: 50
    },
    "320x100": {
        width: 320,
        height: 100
    },
    "728x90": {
        width: 728,
        height: 90
    },
    "728x112": {
        width: 728,
        height: 112
    },
    "970x250": {
        width: 970,
        height: 250
    },
    "336x280": {
        width: 336,
        height: 250
    },
    "300x250": {
        width: 300,
        height: 250
    },
    "300x170": {
        width: 300,
        height: 170
    }
};
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e4qvkgu0"
})(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(0)
    };
});
var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu1"
})(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        top: 0,
        left: theme.spacing(2),
        padding: theme.spacing(0.25, 1),
        color: theme.theme_component_advertisement_slot_label_color || theme.palette.secondary.contrastText,
        backgroundColor: theme.theme_component_advertisement_slot_label_background_color || theme.palette.secondary.main,
        borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0 0"),
        transform: "translateY(-90%) scale(0.75)"
    };
});
var Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu2"
})("display:flex;justify-content:center;align-items:center;width:100%;height:100%;");
var AdvertisementSlot_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var SlotContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu3"
})(function(param) {
    var variant = param.variant;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, AD_SIZES[variant]), {
        overflow: "hidden"
    });
});
var AdvertisementSlot = function(props) {
    var className = props.className, variant = props.variant, slotIdentifier = props.slotIdentifier, alignment = props.alignment, configuration = props.configuration, _adType = props.adType, adType = _adType === void 0 ? "default" : _adType, other = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "variant",
        "slotIdentifier",
        "alignment",
        "configuration",
        "adType"
    ]);
    var captionRef = react.useRef(null);
    var themeOverride = (0,useTheme/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("advertisement_slot").t;
    var useConfig = (0,AppContext/* useAppContext */.bp)().useConfig;
    var componentOptions = useConfig().componentOptions;
    var subMode = componentOptions.component_project_subscription_mode;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("user-token", ""), 1), userToken = ref[0];
    var hideAdvertisement = subMode && userToken;
    var renderAdContent = function() {
        return adType === "pgs" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Inner, {
            dangerouslySetInnerHTML: {
                __html: "<pgs-ad data-pg-ad-spot='".concat(slotIdentifier, '\' style="width: 100%; height: 100%"></pgs-ad>')
            },
            style: {
                justifyContent: alignment,
                width: "100%",
                height: "100%"
            }
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Inner, {
            id: slotIdentifier,
            style: {
                justifyContent: alignment
            }
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, useEditorHandlers("Advertisement Slot", configuration), other), {
        children: hideAdvertisement ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlot_Typography, {
                        ref: captionRef,
                        variant: "caption",
                        component: "div",
                        children: t("label", "Advertisement")
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlotContainer, {
                    variant: variant,
                    slotIdentifier: slotIdentifier,
                    theme: themeOverride,
                    children: renderAdContent()
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/index.ts



/***/ }),

/***/ 7500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export NextLinkComposed */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73966);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23795);
/* harmony import */ var _contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15888);












// Add support for the sx prop for consistency with the other branches.
var Anchor = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("a")({});
var NextLinkComposed = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NextLinkComposed(props, ref) {
    var to = props.to, linkAs = props.linkAs, replace = props.replace, scroll = props.scroll, shallow = props.shallow, prefetch = props.prefetch, locale = props.locale, storybook = props.storybook, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "to",
        "linkAs",
        "replace",
        "scroll",
        "shallow",
        "prefetch",
        "locale",
        "storybook"
    ]);
    return storybook ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    }) : /* next-translate-routes/link is using the wrong Type for next/link. */ /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    });
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/api-reference/next/link
var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Link(props, ref) {
    var _activeClassName = props.activeClassName, activeClassName = _activeClassName === void 0 ? "active" : _activeClassName, as = props.as, classNameProps = props.className, href = props.href, linkAsProp = props.linkAs, locale = props.locale, noLinkStyle = props.noLinkStyle, prefetch = props.prefetch, replace = props.replace, role = props.role, scroll = props.scroll, shallow = props.shallow, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "activeClassName",
        "as",
        "className",
        "href",
        "linkAs",
        "locale",
        "noLinkStyle",
        "prefetch",
        "replace",
        "role",
        "scroll",
        "shallow"
    ]);
    var enabled = (0,_contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__/* .useCursorContext */ .r)().enabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var storybook = router === null || router === void 0 ? void 0 : router.storybook;
    var _$ref;
    var pathname = typeof href === "string" ? href : (_$ref = href === null || href === void 0 ? void 0 : href.pathname) !== null && _$ref !== void 0 ? _$ref : "/";
    var className = (0,clsx__WEBPACK_IMPORTED_MODULE_9__["default"])(classNameProps, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, activeClassName, router.pathname === pathname && activeClassName));
    var isExternal = typeof href === "string" && (href.indexOf("http") === 0 || href.indexOf("mailto:") === 0);
    if (isExternal) {
        if (noLinkStyle) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                className: className,
                href: enabled ? "#" : href,
                ref: ref
            }, other));
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            href: enabled ? "#" : href,
            ref: ref
        }, other));
    }
    var linkAs = linkAsProp || as;
    var nextjsProps = {
        to: enabled ? "#" : href,
        linkAs: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        prefetch: prefetch,
        locale: locale,
        storybook: storybook
    };
    if (noLinkStyle) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(NextLinkComposed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            ref: ref
        }, nextjsProps, other));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        component: NextLinkComposed,
        className: className,
        ref: ref
    }, nextjsProps, other));
});


/***/ }),

/***/ 80830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ PaperColorElevation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
;// CONCATENATED MODULE: ./src/components/PaperColorElevation/PaperColorElevation.tsx







var PaperStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "e4eo54y0"
})(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        boxShadow: theme.shadows[elevation || 1],
        backgroundColor: theme.palette.mode === "dark" ? (0,colorManipulator/* lighten */.$n)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0) : (0,colorManipulator/* darken */._j)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0)
    };
});
var PaperColorElevation = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/PaperColorElevation/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ }),

/***/ 97691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/layouts/DefaultNestedLayout/index.tsx

/**
 * This component is used as fallback nested layout in case no layout component for a page
 * is set during a BigBang site build.
 *
 * This layout can be used as example "NestedLayout" component within our NPM framework.
 *
 * @param props LayoutProps
 * @constructor
 */ function DefaultNestedLayout(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/DefaultLayout/index.tsx



/**
 * Extend the page view component with this component through "Component.getLayout".
 * This component is used as higher order component within _app.tsx.
 * https://nextjs.org/docs/basic-features/layouts
 * @param props LayoutProps
 * @constructor
 */ function DefaultLayout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultNestedLayout, {
        pageContext: pageContext,
        children: children
    });
}

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/types/static.tsx
var types_static = __webpack_require__(17637);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/CursorContext/index.tsx
var CursorContext = __webpack_require__(15888);
// EXTERNAL MODULE: ./src/components/AdvertisementSlot/index.ts + 2 modules
var AdvertisementSlot = __webpack_require__(29918);
;// CONCATENATED MODULE: ./src/layouts/LayoutA/LayoutAds.tsx











var SectionRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ke4zxi0"
})(function(param) {
    var theme = param.theme;
    return {
        width: 332,
        marginTop: theme.spacing(7),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        "@media screen and (max-width: 1220px)": {
            display: "none"
        }
    };
});
var AdvertisementSlotTop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot.AdvertisementSlot, {
    target: "e1ke4zxi1"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0]
    };
});
var AdvertisementSlotBottom = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot.AdvertisementSlot, {
    target: "e1ke4zxi2"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        marginTop: theme.spacing(4)
    };
});
var AdvertisementTop = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotTop, {
        configuration: types_static/* LAYOUTADSCONFIGRATION_AC */._x,
        areaName: "aLayoutRightTopAds",
        elevation: 1,
        slotIdentifier: id || "idhb-right-300",
        variant: "300x600"
    });
};
var AdvertisementBottom = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
        configuration: types_static/* LAYOUTADSCONFIGRATION_AC_BOTTOM */.LL,
        areaName: "aLayoutRightTopAds",
        elevation: 1,
        slotIdentifier: id || "idhb-right-small-300",
        variant: "300x250"
    });
};
var LayoutAds = function() {
    var router = (0,next_router.useRouter)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var theme = (0,useTheme/* default */.Z)();
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var isBetweenMdAndLg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.between("md", "lg"));
    var mdDown = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var ref = appContext.useConfig(), componentOptions = ref.componentOptions, project = ref.project;
    var panel = (0,CursorContext/* useCursorContext */.r)().panel;
    var header_lift = project.features.ads.header_lift;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), adsRequest = ref1[0], setAdsRequest = ref1[1];
    react.useEffect(function() {
        if (header_lift) {
            __webpack_require__.e(/* import() */ 8505).then(__webpack_require__.bind(__webpack_require__, 18505)).then(function(module) {
                setAdsRequest(module.adsRequest);
            });
        }
    }, [
        header_lift
    ]);
    var layoutAdsElements = {
        "idhb-right-300": !(componentOptions.component_layout_right_ads_disabled || componentOptions.component_layout_right_tablet_ads_disabled || componentOptions.component_layout_right_ads_mobile_disabled),
        "idhb-right-small-300": !(componentOptions.component_layout_right_middle_ads_disabled || componentOptions.component_layout_right_middle_tablet_ads_disabled || componentOptions.component_layout_right_middle_mobile_ads_disabled)
    };
    var adsList = Object.keys(layoutAdsElements).filter(function(key) {
        return layoutAdsElements[key];
    });
    react.useEffect(function() {
        if (header_lift && adsRequest && adsList.length > 0) {
            adsRequest(adsList);
        }
    }, [
        adsRequest,
        adsList,
        header_lift
    ]);
    react.useEffect(function() {
        if (!header_lift || !adsRequest) return;
        var events = router.events;
        var handleRouteChange = function() {
            if (adsList.length > 0 && !componentOptions.component_ads_disabled) {
                adsRequest(adsList);
            }
        };
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router,
        header_lift
    ]);
    return panel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionRight, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {})
        ]
    }) : !componentOptions.component_ads_disabled && adsList.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionRight, {
        children: [
            lg && !componentOptions.component_layout_right_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {
                id: componentOptions.component_right_ads_id
            }),
            isBetweenMdAndLg && !componentOptions.component_layout_right_tablet_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {
                id: componentOptions.component_right_ads_id
            }),
            mdDown && !componentOptions.component_layout_right_ads_mobile_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {
                id: componentOptions.component_right_ads_id
            }),
            lg && !componentOptions.component_layout_right_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {
                id: componentOptions.component_right_middle_ads_id
            }),
            isBetweenMdAndLg && !componentOptions.component_layout_right_middle_tablet_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {
                id: componentOptions.component_right_middle_ads_id
            }),
            mdDown && !componentOptions.component_layout_right_middle_mobile_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {
                id: componentOptions.component_right_middle_ads_id
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/LayoutA/LayoutA.tsx




var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k4na950"
})(function() {
    return {
        display: "flex",
        flex: 1,
        flexGrow: 1,
        flexDirection: "row",
        flexWrap: "nowrap",
        alignSelf: "center",
        height: "auto",
        justifyContent: "center",
        maxWidth: "1200px",
        margin: "0 auto"
    };
});
var SectionLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k4na951"
})(function() {
    return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        flex: 1,
        height: "auto"
    };
});
var LayoutA = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionLeft, {
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutAds, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/LayoutA/index.ts


;// CONCATENATED MODULE: ./src/generated/index/layout.tsx



function Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/game/layout.tsx



function layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/search/layout.tsx



function search_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/category/layout.tsx



function category_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/categories/layout.tsx



function categories_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/collection/layout.tsx



function collection_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/collections/layout.tsx



function collections_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/BaseLayout/index.tsx




// IMPORTANT: The page.name in the import and switch case must match with the pageType set in the BaseLayoutProps definition!







var NavigationBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4301).then(__webpack_require__.bind(__webpack_require__, 74301)).then(function(mod) {
        return mod.NavigationBarEmpty;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74301)
            ];
        }
    },
    ssr: true
});
var FooterBar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(2973)]).then(__webpack_require__.bind(__webpack_require__, 2973)).then(function(mod) {
        return mod.FooterBarEmpty;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2973)
            ];
        }
    },
    ssr: true
});
function BaseLayout(props) {
    var children = props.children, pageType = props.pageType, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBar, {}),
            function() {
                switch(pageType){
                    case "index":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "game":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "search":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "category":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(category_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "categories":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(categories_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "collection":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collection_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "collections":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collections_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    default:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultLayout, {
                            pageContext: pageContext,
                            children: children
                        });
                }
            }(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBar, {})
        ]
    });
}


/***/ })

}]);